import { Calculation } from "../models/Calculation";

export class CalculationSearchResult {
    constructor(
        public calculationId: string,
        public calculation: Calculation,
        public path: Array<number>,
        public topLevelParent: Calculation | undefined,
        public parent?: Calculation
    ) { }
}

export class CalculationsSearchService {

    public static findCalculationByIdRecursive(
        calculations: Calculation[],
        targetId: string
    ): CalculationSearchResult | null {
        return this.search(calculations, targetId);
    }

    private static search(
        calculations: Calculation[],
        targetId: string,
        parent?: Calculation,
        topLevelParent?: Calculation,
        path: number[] = []
    ): CalculationSearchResult | null {
        for (let i = 0; i < calculations.length; i++) {
            const calculation = calculations[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? calculation;

            if (calculation.id === targetId) {
                return new CalculationSearchResult(targetId, calculation, currentPath, currentTopLevel, parent);
            }

            const nestedCalculations = calculation.configuration?.calculations;
            if (Array.isArray(nestedCalculations)) {
                throw new Error("Calculations containing child calculations is not supported.");
                // const result = this.search(nestedCalculations, targetId, calculation, currentTopLevel, currentPath);
                // if (result) return result;
            }
        }

        return null;
    }

    public static setCalculationAtPath(
        topLevelParent: Calculation,
        path: number[],
        newCalculation: Calculation
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentCalculations = topLevelParent.configuration?.calculations;
        if (!Array.isArray(currentCalculations)) return false;

        // Traverse to the parent of the target calculation
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const calculation = currentCalculations[index];
            if (!calculation?.configuration?.calculations) return false;

            currentCalculations = calculation.configuration.calculations;
        }

        const targetIndex = path[path.length - 1];

        // Replace the target calculation
        if (currentCalculations && currentCalculations[targetIndex]) {
            currentCalculations.splice(targetIndex, 1, newCalculation);
            return true;
        }

        return false;
    }
}
